import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";

const FAQManagement = (props) => {
  const { t } = useTranslation();
  const [attributes] = useState([
    {
      type: "number",
      placeholder: "order",
      name: "order",
      validation: "",
      default: "",
      label: "order",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "question",
      name: "question",
      validation: "",
      default: "",
      label: "question",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "textarea",
      placeholder: "answer",
      name: "answer",
      validation: "",
      default: "",
      label: "answer",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    // {
    //   type: "select",
    //   placeholder: "addedBy",
    //   name: "addedBy",
    //   validation: "addedBy",
    //   showItem: "fullName",
    //   collection: "addedBy",
    //   filter: false,
    //   default: "",
    //   label: "addedBy",
    //   required: true,
    //   view: true,
    //   add: false,
    //   update: false,
    // },
    {
      type: "select",
      placeholder: "category",
      name: "category",
      validation: "",
      showItem: "locale",
      default: "",
      label: "category",
      required: true,
      view: true,
      add: true,
      update: true,
      apiType: "API",
      selectApi: "faq-category/select"
    },
    {
      type: "number",
      placeholder: "order",
      name: "order",
      validation: "",
      default: "",
      label: "order",
      required: true,
      view: false,
      add: true,
      update: true,
    },
    {
      type: "date",
      placeholder: "createdAt",
      name: "createdAt",
      validation: "",
      default: "",
      label: "createdAt",
      required: true,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "checkbox",
      placeholder: "active",
      name: "isActive",
      validation: "",
      showItem: "",
      default: "true",
      label: "active",
      required: true,
      view: false,
      tag: false,
      add: true,
      update: true,
    },
    {
      type: "expired",
      placeholder: "status",
      name: "isActive",
      validation: "",
      showItem: "",
      default: "",
      label: "status",
      required: true,
      view: true,
      tag: true,
      add: false,
      update: false,
      value: "Active",
      ifNull: "Inactive",
    },
  ]);

  useEffect(() => {
    document.title = `${t("faqs")} - PersoBase`;
  }, [t]);

  return (
    <Container className="noshadow">
      <ListTable formMode="double" {...props} actions={[]} api={`faq`} itemTitle={`question`} shortName={`FAQ`} addPrivilege={true} delPrivilege={true} updatePrivilege={true} attributes={attributes}></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(FAQManagement);
